import BaseModal from "@components/modals/BaseModal";
import Button from "@components/ui/buttons/Button";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import Icon1 from "@assets/icons/Icon";
import { useState } from "react";

export default function ConfirmationModal({
  title = "Êtes-vous sûr de vouloir supprimer cet objet ?",
  onClose,
  onConfirm,
  message,
  confirmText,
  confirmLabel,
  extraContent,
}: {
  title?: string;
  onClose: () => void;
  onConfirm?: () => void;
  message?: string;
  confirmText?: string;
  confirmLabel?: string;
  extraContent?: React.ReactNode;
}) {
  const [inputValue, setInputValue] = useState("");
  const requiresTyping = !!confirmText;
  const isConfirmEnabled = !requiresTyping || inputValue === confirmText;

  return (
    <BaseModal
      title="Confirmation"
      startIcon={<Icon1 name="warning" size={20} />}
      onClose={onClose}
    >
      <div className="bg-white flex flex-col gap-3 p-4">
        <div className="text-h2 font-medium text-black">{title}</div>
        {message && <div className="text-h3 text-neutral-500">{message}</div>}
        {extraContent}
        {requiresTyping && (
          <div className="flex flex-col gap-2 mt-2">
            <div className="text-h3 text-neutral-500">
              Écrivez{" "}
              <span className="font-bold text-red-500">{confirmText}</span> pour
              confirmer
            </div>
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder={confirmText}
              className="w-full px-3 py-2 border rounded-lg text-sm outline-none focus:ring-2 focus:ring-red-200 focus:border-red-400"
            />
          </div>
        )}
      </div>

      <div className="border-t-1 p-4 flex flex-row justify-end gap-2">
        <SecondaryButton variant="small" onClick={onClose}>
          Annuler
        </SecondaryButton>
        <Button
          variant="small"
          label={confirmLabel || "Oui, supprimer"}
          onClick={onConfirm}
          disabled={!isConfirmEnabled}
          className={isConfirmEnabled ? "bg-red-500 hover:bg-red-600" : ""}
        />
      </div>
    </BaseModal>
  );
}
